import {listTTPhieuKho} from "data/list";
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {ColumnsEdit} from "types/models/column-table-edit";
import {DataFormField} from "types/models/input-field-type";

const {INPUT, CURRENCY, DATE, NUMBER, COMBO_BOX, CODE, AUTO_COMPLETE} =
  FIELD_TYPE;
const inputFields: DataFormField[] = [
  {
    type: INPUT,
    label: "Mã phiếu",
    name: "id",
    disable: true,
  },
  {
    type: INPUT,
    label: "Tiêu đề phiếu",
    name: "tieuDe",
  },
  {
    type: DATE,
    label: "Ngày hóa đơn",
    name: "ngayHoaDon",
  },
  {
    type: INPUT,
    label: "Số hóa đơn",
    name: "soHoaDon",
  },
  {
    type: COMBO_BOX,
    label: "Kho nhập/đề nghị",
    name: "khoNhapId",
    rules: [{required: true, message: "Chưa chọn kho nhập/đề nghị"}],
  },
  {
    type: COMBO_BOX,
    label: "Nhà cung cấp",
    name: "nhaCungCapId",
    // rules: [{required: true, message: "Chưa chọn nhà "}],
  },
  {
    type: COMBO_BOX,
    label: "Kho xuất/cấp",
    name: "khoXuatId",
  },
  {
    type: COMBO_BOX,
    label: "Nguồn VTYT",
    name: "nguonVTYTId",
    rules: [{required: true, message: "Chưa chọn nguồn VTYT"}],
  },

  {
    type: INPUT,
    label: "Người lập phiếu",
    name: "nguoiLap",
    rules: [{required: true, message: "Chưa điền người lập phiếu"}],
  },
  {
    type: DATE,
    label: "Ngày dự trù",
    name: "ngayDuTru",
  },
  {
    type: INPUT,
    label: "Người giao",
    name: "nguoiGiao",
  },
  {
    type: INPUT,
    label: "Người nhận",
    name: "nguoiNhan",
  },
  {
    type: DATE,
    label: "Thời điểm hoàn thành",
    name: "ngayHoanThanh",
    disable: true,
  },

  {
    type: CURRENCY,

    label: "Tổng giá trị",
    name: "tongGiaTri",
    disable: true,
  },
  {
    type: COMBO_BOX,
    label: "Tình trạng phiếu",
    name: "tinhTrang",
    options: listTTPhieuKho,
    disable: true,
  },
  {
    type: INPUT,
    label: "Ghi chú",
    name: "ghiChu",
  },
];
const columns: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: 60,
    show: true,
    align: "center",
  },
  {
    type: AUTO_COMPLETE,
    dataIndex: "vtytid",
    key: "vtytid",
    title: "Mã VTYT",
    show: true,
    width: 160,
    autoFocus: true,
    align: "center",
  },

  {
    type: AUTO_COMPLETE,
    dataIndex: "tenTheoThuongMai",
    key: "tenTheoThuongMai",
    title: "Tên thương mại",
    show: true,
    width: 280,
  },
  {
    type: AUTO_COMPLETE,
    dataIndex: "soLo",
    key: "soLo",
    title: "Số lô",
    show: true,
    width: 250,
    align: "left",
  },
  {
    type: INPUT,
    dataIndex: "soLoNCC",
    key: "soLoNCC",
    title: "Số lô của NCC",
    show: true,
    align: "left",
    width: 150,
  },
  {
    type: NUMBER,
    dataIndex: "soLuongTon",
    key: "soLuongTon",
    title: "SL tồn",
    show: true,
    disabled: true,
    width: 90,
    align: "center",
  },
  {
    type: NUMBER,
    dataIndex: "soLuong",
    key: "soLuong",
    title: "Số nhập",
    show: true,
    width: 90,
    rules: [{required: true, message: "Chưa nhập số lượng"}],
  },
  {
    type: DATE,
    dataIndex: "ngayHetHan",
    key: "ngayHetHan",
    title: "Ngày hết hạn",
    show: true,
    disabled: true,
    width: 150,
    align: "center",
  },
  {
    type: DATE,
    dataIndex: "ngayThongBaoHH",
    key: "ngayThongBaoHH",
    title: "Ngày thông báo hết hạn",
    show: true,
    width: 150,
    align: "center",
  },
  {
    type: CURRENCY,
    dataIndex: "donGiaNhap",
    key: "donGiaNhap",
    title: "Đơn giá nhập",
    show: true,
    width: 150,
    align: "right",
  },

  {
    type: NUMBER,
    dataIndex: "vat",
    key: "vat",
    title: "VAT(%)",
    show: true,
    width: 80,
    align: "right",
  },
  {
    type: NUMBER,
    dataIndex: "discount",
    key: "discount",
    title: "Discount(%)",
    show: true,
    width: 100,
    align: "right",
  },
  {
    type: CURRENCY,
    dataIndex: "giaTriHang", //= donGiaNhap * soLuong
    key: "giaTriHang",
    title: "Giá trị",
    show: true,
    disabled: true,
    width: 150,
    align: "right",
  },
  {
    type: CURRENCY,
    dataIndex: "donGiaXuat",
    key: "donGiaXuat",
    title: "Đơn giá xuất",
    show: true,
    width: 150,
    align: "right",
  },
  {
    type: COMBO_BOX,
    dataIndex: "quyCachId",
    key: "quyCachId",
    title: "Quy cách",
    show: true,
    width: 180,
  },
  {
    type: COMBO_BOX,
    dataIndex: "donViTinhId",
    key: "donViTinhId",
    title: "Đơn vị tính",
    show: true,
    width: 90,
  },
  {
    type: COMBO_BOX,
    dataIndex: "nhomVTYTId",
    key: "nhomVTYTId",
    title: "Nhóm VTYT",
    show: true,
    width: 120,
  },

  {
    type: DATE,
    dataIndex: "ngaySanXuat",
    key: "ngaySanXuat",
    title: "Ngày sản xuất",
    show: true,
    disabled: true,
    width: 150,
    align: "center",
  },

  {
    type: CURRENCY,
    dataIndex: "giaTriBHChiTra",
    key: "giaTriBHChiTra",
    title: "Giá trị BH chi trả",
    show: true,
    disabled: true,
    width: 150,
    align: "right",
  },
  {
    type: INPUT,
    dataIndex: "maBaoHiem",
    key: "maBaoHiem",
    title: "Mã BH",
    show: true,
    disabled: true,
    width: 120,
    align: "center",
  },
  {
    type: AUTO_COMPLETE,
    dataIndex: "maHang",
    key: "maHang",
    title: "Mã hàng",
    show: true,
    width: 220,
    align: "center",
  },
  {
    type: INPUT,
    dataIndex: "tenTheoBaoHiem",
    key: "tenTheoBaoHiem",
    title: "Tên theo BH",
    show: true,
    disabled: true,
    width: 120,
  },
  {
    type: COMBO_BOX,
    dataIndex: "hangSanXuatId",
    key: "hangSanXuatId",
    title: "Hãng sản xuất",
    show: true,
    width: 120,
  },
  {
    type: COMBO_BOX,
    dataIndex: "nuocSanXuatId",
    key: "nuocSanXuatId",
    title: "Nước sản xuất",
    show: true,
    width: 150,
  },

  // {
  //   type: COMBO_BOX,
  //   dataIndex: "donViApKQDTId",
  //   key: "donViApKQDTId",
  //   title: "Tên đơn vị áp KQĐT",
  //   show: true,
  //   width: 120,
  // },
  {
    type: INPUT,
    dataIndex: "nhaThau",
    key: "nhaThau",
    title: "Nhà thầu trúng thầu",
    show: true,
    width: 220,
  },
  {
    type: INPUT,
    dataIndex: "decision",
    key: "decision",
    title: "Quyết định thầu",
    show: true,
    width: 220,
  },
  {
    type: INPUT,
    dataIndex: "bidCode",
    key: "bidCode",
    title: "Số thầu",
    show: true,
    width: 220,
  },
  {
    type: INPUT,
    dataIndex: "nhomTCKT",
    key: "nhomTCKT",
    title: "Nhóm TCKT",
    show: true,
    width: 120,
  },
  {
    type: INPUT,
    dataIndex: "description",
    key: "description",
    title: "Mô tả",
    show: true,
    width: 120,
  },
  {
    type: INPUT,
    dataIndex: "note",
    key: "note",
    title: "Ghi chú",
    show: true,
    width: 120,
  },
  {
    title: "",
    dataIndex: "",
    key: "action",
    align: "center",
    width: 60,
    fixed: "right" as any,
    show: true,
  },
];
export {inputFields, columns};
